export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10379.28faf45e.jpg";